<template>
  <div class="basic-block block-about-mitsuri">
    <picture>
      <source srcset="/static/img/recommend/lp/houen/about_mitsuri.webp" type="image/webp">
      <img src="/static/img/recommend/lp/houen/about_mitsuri.jpg" alt="">
    </picture>
  </div>
</template>

<script>

export default {
  name: 'BlockAboutMitsuri',
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

.block-about-mitsuri {
  background: #fff;
  padding: 60px 0 40px;
  img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/houen/blocks/BlockAboutMitsuri.vue